import React, { useEffect, useState } from 'react';

const LoadingScreen = ({ children }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        // Проверяем, загружены ли все критические ресурсы
        const checkResources = () => {
            const images = document.querySelectorAll('img[data-src]');
            const backgroundLoaded = document.body.style.backgroundImage !== '';

            // Если нет изображений для загрузки и фон загружен
            if (images.length === 0 && backgroundLoaded) {
                setIsLoaded(true);
                document.body.classList.remove('loading');
                document.body.classList.add('loaded');
                return;
            }

            // Проверяем загрузку изображений
            let loadedImages = 0;
            images.forEach(img => {
                if (img.complete) {
                    loadedImages++;
                }
            });

            if (loadedImages === images.length && backgroundLoaded) {
                setIsLoaded(true);
                document.body.classList.remove('loading');
                document.body.classList.add('loaded');
            }
        };

        // Проверяем сразу
        checkResources();

        // Проверяем через небольшие интервалы
        const interval = setInterval(checkResources, 100);

        // Максимальное время ожидания - 2 секунды
        const timeout = setTimeout(() => {
            setIsLoaded(true);
            document.body.classList.remove('loading');
            document.body.classList.add('loaded');
            clearInterval(interval);
        }, 2000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);

    if (!isLoaded) {
        return (
            <div className="loading-screen">
                <div className="loading-content">
                    Загрузка...
                </div>
            </div>
        );
    }

    return children;
};

export default LoadingScreen;
